// extracted by mini-css-extract-plugin
export var brand = "_3s-9";
export var button = "_3s-0";
export var chevron = "_3s-v";
export var chevronButton = "_3s-w";
export var content = "_3s-n";
export var danger = "_3s-g";
export var dangerOutlined = "_3s-h";
export var dark = "_3s-l";
export var darkTheme = "_3s-c";
export var extraSmall = "_3s-4";
export var fullWidth = "_3s-8";
export var ghost = "_3s-d";
export var gray = "_3s-t";
export var icon = "_3s-p";
export var iconButton = "_3s-s";
export var iconButtonBorder = "_3s-x";
export var iconButtonBorderDark = "_3s-y";
export var iconButtonBorderLight = "_3s-z";
export var iconLeft = "_3s-q";
export var iconRight = "_3s-r";
export var large = "_3s-1";
export var light = "_3s-m";
export var medium = "_3s-2";
export var micro = "_3s-5";
export var nano = "_3s-7";
export var outlined = "_3s-k";
export var pending = "_3s-a";
export var primary = "_3s-i";
export var shadow = "_3s-o";
export var small = "_3s-3";
export var solidLight = "_3s-e";
export var solidLightBrand = "_3s-f";
export var spinner = "_3s-u";
export var transparent = "_3s-j";
export var warning = "_3s-b";
export var wideNano = "_3s-6";